export default {"src":"/_next/static/media/usps.6ada547c.svg","height":24,"width":145,"blurWidth":0,"blurHeight":0};